import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { SelectContractorDataEntity } from 'src/app/models/data-entities/select-contractor-data-entity';
import { Contractor } from 'src/app/models';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-select-contractor-data-entity-view',
  templateUrl: './select-contractor-data-entity-view.component.html',
  styleUrl: './select-contractor-data-entity-view.component.css',
  standalone: false
})
export class SelectContractorDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  entity: SelectContractorDataEntity;
  contractor: Contractor;

  ngOnInit(): void {
    this.contractor = this.entity?.contractor;
  }
  templateForPermitForm: boolean
  constructor(
 public layoutService: LayoutService,
    resolver: ComponentFactoryResolver,
    context : WorkflowContextService

  ) {
    super(layoutService, resolver, context)
    //added by priya 24-12-2025
   layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    //end by priya 24-12-2025
  }
}
